import { render, staticRenderFns } from "./salesperson.vue?vue&type=template&id=528fb222"
import script from "./salesperson.vue?vue&type=script&lang=js"
export * from "./salesperson.vue?vue&type=script&lang=js"
import style0 from "./salesperson.vue?vue&type=style&index=0&id=528fb222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports